import { ApiEndpoints } from "@shared/api/api-endpoints";
import {
  communicationApiClient,
  onboardingApiClient,
} from "@shared/api/clients/apiClientFactory";

export const uxSettingsApi = {
  createEmailSignature: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "email-signatures"
    );
    const response = await communicationApiClient.post(url, payload);
    return response.data || response.data.result;
  },

  updateEmailSignature: async (payload: any, signatureId: string) => {
    const response = await communicationApiClient.patch(
      `email-signatures/${signatureId}/`,
      payload
    );
    return response.data.result || response.data;
  },

  getAllEmailSignatures: async (
    utilityId: string,
    page: number,
    limit: number,
    search?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "email-signatures",
      (query) => {
        query.push("remote_utility_id", utilityId);
        query.push("page", page);
        query.push("limit", limit);
        if (search) {
          query.push("search_data", search);
        }
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
  updateEmailSignatureStatus: async (
    payload: any,
    signatureId: string
  ): Promise<any> => {
    const response = await communicationApiClient.patch(
      `email-signatures/set-default/${signatureId}/`,
      payload
    );
    return response.data.result || response.data;
  },
  deleteEmailSignature: async (signatureId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `email-signatures/${signatureId}`
    );
    const response = await communicationApiClient.delete(url);
    return response.data ?? [];
  },
  getEmailSignatures: async (id: string, utilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `email-signatures/${id}`,
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },

  getAllSegments: async (
    utilityId: string,
    page: number,
    limit: number,
    search?: string,
    audienceType?:string,criteria?:string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "segments",
      (query) => {
        query.push("remote_utility_id", utilityId);
        query.push("page", page);
        query.push("limit", limit);
        if (search) {
          query.push("search_data", search);
        }
        if (audienceType) {
          query.push("audience_type", audienceType);
        }
        if (criteria) {
          query.push("criteria", criteria);
        }
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },

  deleteSegment: async (segmentId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `segments/${segmentId}`
    );
    const response = await communicationApiClient.delete(url);
    return response.data ?? [];
  },

  getSegment: async (id: string, utilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `segments/${id}`,
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data;
  },

  createSegment: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "segments"
    );
    const response = await communicationApiClient.post(url, payload);
    return response.data || response.data.result;
  },

  updateSegment: async (payload: any, segmentId: string): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `segments/${segmentId}`
    );
    const response = await communicationApiClient.patch(url, payload);
    return response.data || response.data.result;
  },

  getFilterFields: async (utilityId: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      "segments/filter-fields",
      (query) => {
        query.push("remote_utility_id", utilityId);
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
  getCatSubCatChoices: async (
    name: string,
    remoteUtilityId: string,
    categoryCode?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      `choices/${name}`,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        if (categoryCode) {
          query.push("category_code", categoryCode);
        }
        return query;
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
  getPlanChoices: async (
    name: string,
    remoteUtilityId: string,
    categoryCode?: string,
    subCategoryCode?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "onboarding",
      `choices/${name}`,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        if (categoryCode) {
          query.push("category", categoryCode);
        }
        if (subCategoryCode) {
          query.push("subcategory", subCategoryCode);
        }
        return query;
      }
    );
    const response = await onboardingApiClient.get(url);
    return response.data;
  },
};
